<template>
  <div class="sidebar-container">
    <div class="sidebar">
      <!-- Logo区域 -->
      <div class="sidebar-logo">
        <div class="logo">
          <img :src="siteCfg && siteCfg.webtool_logo
              ? siteCfg.webtool_logo
              : 'https://img.huajuanyun.com/utools/2023/911/1694415838004.png'
            " alt="" />
        </div>
      </div>
      <!-- 菜单区域 -->
      <el-menu :default-active="activeIndex" router class="sidebar-menu" mode="vertical" :unique-opened="false"
        background-color="#ffffff" text-color="#111111" :active-text-color="getThemeColor()">
        <template v-for="item in menuList">
          <div v-if="item.divider" :key="item.key" class="menu-divider">
            <span class="divider-text">{{ item.text }}</span>
          </div>
          <el-menu-item v-else :key="item.path" :index="item.path">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
export default {
  name: "Sidebar",
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeIndex: ""
    };
  },
  computed: {
    siteCfg() {
      return this.$store.getters.config;
    },
    showDygaoyongMenu() {
      const userInfo = this.$store.getters.info;
      return Number(userInfo && userInfo.pc_dy_goods) === 1;
    },
    // 是否为子账号
    isSubAccount() {
      const userInfo = this.$store.getters.info;
      if (!userInfo) {
        return false;
      }
      return userInfo.sub_account_info && userInfo.sub_account_info.username
    },
    webtoolMenus() {
      // webtool_menus 值: 1=订单管理 2=带货榜单 3=团队成员
      let originMenus = []
      if (this.siteCfg) {
        originMenus = (this.isSubAccount ? this.siteCfg.webtool_menus_child : this.siteCfg.webtool_menus) || []
      }
      const menus = originMenus
        ? String(originMenus).split(',').map(Number)
        : []
      return menus
    },
    menuList() {
      const allMenus = [
        { name: '控制台', path: '/dashboard', icon: 'el-icon-monitor', menuKey: 0 },
        { name: '批量转链', path: '/home', icon: 'el-icon-link', menuKey: 0 },
        { name: '订单管理', path: '/order', icon: 'el-icon-tickets', menuKey: 1 },
        { name: '带货榜单', path: '/grank', icon: 'el-icon-trophy', menuKey: 2 },
        { name: '团队成员', path: '/team-fans', icon: 'el-icon-user', menuKey: 3 },
      ]
      if (this.webtoolMenus.includes(4) && !this.isSubAccount) {
        allMenus.push({ name: '账号管理', path: '/account', icon: 'el-icon-set-up', menuKey: 4  })
      }
      // menuKey=0 的菜单始终显示，其余根据 webtool_menus 配置显示
      const list = allMenus.filter(item => item.menuKey === 0 || this.webtoolMenus.includes(item.menuKey))
      if (this.showDygaoyongMenu) {
        list.push(
          { divider: true, key: 'dy-divider', text: 'KA高级功能' },
          { name: '抖客商品库', path: '/dytuanzhang', icon: 'el-icon-goods' },
          // { name: '抖音高佣库', path: '/dygaoyong', icon: 'el-icon-s-order' },
          { name: '抖客高佣库', path: '/gaoyong', icon: 'el-icon-medal' },
          { name: '淘宝直播库', path: '/taobao-live', icon: 'el-icon-video-camera' },
          { name: '中免日上', path: '/cdf-sunrise', icon: 'el-icon-shopping-bag-2' }
        )
      }
      return list
    }
  },
  watch: {
    $route(to) {
      this.activeIndex = to.path || '/dashboard';
    },
  },
  mounted() {
    this.activeIndex = this.$route.path || '/dashboard';
    this.refreshUserInfo();
  },
  methods: {
    getThemeColor() {
      return getComputedStyle(document.documentElement).getPropertyValue('--main-bg-color').trim() || '#409EFF'
    },
    refreshUserInfo() {
      const token = getToken();
      if (!token) return;
      this.$store.dispatch('user/getUserInfo').catch(err => {
        console.warn('Failed to refresh user info:', err);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.sidebar-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 200px;
  padding: 0 20px;
  height: 100vh;
  z-index: 1001;
  background-color: #ffffff;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.15);
}

.sidebar {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.sidebar-logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border-bottom: 1px solid #e6e6e6;

  .logo {
    width: 120px;
    max-height: 50px;
    overflow: hidden;

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }
}

.sidebar-menu {
  flex: 1;
  border: none;

  ::v-deep .el-menu-item {
    height: 42px;
    line-height: 42px;
    font-size: 16px;
    border-radius: 100px;
    margin: 15px 0;
    color: #111111;

    &:hover {
      background-color: #f9f9f9;
    }

    &.is-active {
      background-color: var(--main-bg-color) !important;
      color: #fff !important;
      font-weight: bold;

      i {
        color: #fff !important;
      }
    }

    i {
      color: #111111;
      margin-right: 5px;
      font-size: 18px;
    }
  }
}

.menu-divider {
  padding: 15px 0 5px 20px;
  margin-top: 5px;
  border-top: 1px solid #e4e7ed;
  text-align: center;
}

.divider-text {
  font-size: 12px;
  color: #ff6d41;
  letter-spacing: 1px;
}

// 响应式设计
@media (max-width: 768px) {
  .sidebar-container {
    width: 180px;
     .el-menu-item {
      font-size: 14px;
      font-weight: normal;
      color: #111111;
      i {
        margin-right: 2px;
      }
     }
  }
}
</style>
